export default __webpack_public_path__ + "static/media/search.efdad468.svg";